import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useOrdenTrabajoMotivoPausa } from "../../../hooks/useOrdenTrabajo";
import { Skeleton } from "@mui/material";
import UpdateMotivoPausaOtg from "./updateMotivoPausaOtg";
import AddMotivoPausaOtg from "./addMotivoPausaOtg";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function UpdateAreaProcesoProductivo({ setAlertCustom }) {
  const [value, setValue] = React.useState(0);
  const {
    data: ordentrabajoMotivoPausa,
    isLoading: isLoadingOrdentrabajoMotivoPausa,
    refetch,
  } = useOrdenTrabajoMotivoPausa();
  if (isLoadingOrdentrabajoMotivoPausa) {
    return (
      <Box>
        <Skeleton variant="text" />

        <Skeleton variant="rectangular" width={380} height={200} />
      </Box>
    );
  }
  console.log(ordentrabajoMotivoPausa);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={value} onChange={handleChange}>
          <Tab label="Editar" {...a11yProps(0)} />
          <Tab label="Agregar" {...a11yProps(1)} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <UpdateMotivoPausaOtg
          ordentrabajoMotivoPausa={ordentrabajoMotivoPausa}
          setAlertCustom={setAlertCustom}
          refetch={refetch}
        />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <AddMotivoPausaOtg setAlertCustom={setAlertCustom} refetch={refetch} />
      </TabPanel>
    </Box>
  );
}
